import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { ECMID } from '../../../constants';
import { Link,useLocation } from 'react-router-dom';
import Breadcrumb from '../../../component/Breadcrumb';
import LaunchIcon from '@mui/icons-material/Launch';
import { Grid, Typography, Box, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText, IconButton } from '@mui/material';
import { options } from '../../../constants';
import { fetchAutoCompleteSheetData } from '../../../api/mappingApi';
import ClearIcon from '@mui/icons-material/Clear';
import AddressModal from '../AddressModal';
import FormNumberField from '../../../component/NumberInput';

const AddNewTransmitMessages = () => {
    //const inputRef         = useRef(null);
    const location                                      = useLocation();
    const [open, setOpen]                               = React.useState(false);
    const [sheetMappingData, setSheetMappingData]       = React.useState([]);
    const [autoCompleteLoading, setAutoCompleteLoading] = React.useState(false);
    const [searchValue, setSearchValue]                 = React.useState('');
    const [sheetFilter, setSheetFilter]                 = React.useState('');
    const [signalAddress, setSignalAddress]             = React.useState('');
    const [fields,setFields]                            = React.useState({
        Addr        : '',
        ECMID       : '',
        PGN         : '',
        StartByte   : '',
        StartBit    : '',
        Len         : '',
        Scaling     : '',
        Offset      : '',
        NANVal      : '',
        DType       : '',
        SPN         : '',
        SigAddr     : '',
        comments    : ''
    })

    useEffect(()=> {
        if(location.state?.rowId !== '' && location.state?.rowId !== undefined){
            let existingTransmitMessages = JSON.parse(localStorage.getItem('ECUTransmitMessages'));
            setFields(existingTransmitMessages[location.state?.rowId])
        }
    },[location.state?.rowId])

    const changeHandler = (e) => {
        let value = e.target.name === 'PGN' ?  e.target.value.replace(/\D/g, "") : e.target.value;
        let name  = e.target.name;
        setFields((prevState) => ({...prevState, [name]: e.target.name !== 'PGN' ? value : isNaN(parseInt(value)) ? '' : parseInt(value)}))
    }

    const changeHandlerInt = (e) => {
        let value = e.target.value.replace(/\D/g, "");
        let name  = e.target.name;
        setFields((prevState) => ({...prevState, [name]: value}))
    }

    const handleBlurUpdate = (name,value) => {
        let finalVal;
        if(name === 'NANVal' || name === 'Scaling' || name === 'Offset'){
            const result = decimalValidation(name,value);
            if(result){
                swal("Oops!", "Please use Float value for Scaling, Offset and NANVal!", "error");
            }
            if(value % 1 === 0){
                value = Number(value) === 0 ? 0.000001 : parseFloat(value) + 0.000001;
            }
            finalVal = value ? parseFloat(value) : ''; 
        } else {
            finalVal = parseInt(value); 
        }
        setFields((prevState) => ({...prevState, [name]: finalVal}));
        // setFields((prevState) => ({...prevState, [name]: isNaN(parseFloat(value)) ? '' : parseFloat(value)}));
    } 


    const decimalValidation = (name,value) => {
        let validationArray = ['NANVal','Scaling','Offset'];
        if(validationArray.includes(name) && value !== '' && value?.toString()?.indexOf('.') === -1) {
            return true;
        } 
        return false;
    }

    const handleSubmit = () => {
        
        const isEmpty = !Object.values(fields).every(val => val !== null && val !== '');
        if(isEmpty){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }

        let valdationStatus = false;
        Object.keys(fields).forEach(function(key) {
            const result = decimalValidation(key,fields[key]);
            if(result){
                valdationStatus = true;
            }        
        });

        if(valdationStatus){
            swal("Oops!", "Please use Float value for Scaling, Offset and NANVal!", "error");
            return false;
        }

        let existingTransmitMessages = JSON.parse(localStorage.getItem('ECUTransmitMessages'));
        if(location.state?.rowId !== '' && location.state?.rowId !== undefined){ 
            existingTransmitMessages[location.state?.rowId] = fields;
            localStorage.setItem('ECUTransmitMessages',JSON.stringify(existingTransmitMessages));
            swal({
                title: "Success",
                text: 'ECUID Transmit Message updated successfully.',
                icon: "success",
            })
        } else {
            if(existingTransmitMessages == null) existingTransmitMessages = [];
            existingTransmitMessages.push(fields);
            localStorage.setItem('ECUTransmitMessages',JSON.stringify(existingTransmitMessages));
            swal({
                title: "Success",
                text: 'ECU Transmit Messages added successfully.',
                icon: "success",
            })
            setFields({
                Addr        : '',
                ECMID       : '',
                PGN         : '',
                StartByte   : '',
                StartBit    : '',
                Len         : '',
                Scaling     : '',
                Offset      : '',
                NANVal      : '',
                DType       : '',
                SPN         : '',
                SigAddr     : '',
                comments    : ''
            })
        }
    }

    const handleClickOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        setSearchValue('');
        setSheetFilter('');
    };

    const handleSheetFilter = (e) => {
        setSheetFilter(e.target.value)
    }

    const handleSearchValueAutoComplete = (value) => {
        setSearchValue(value)
    }

    useEffect(() => {
        if(searchValue === ''){
            setSheetMappingData([]);
            return;
        }
        let active;
        if(sheetFilter){
            active = true;
            ( async () => {
                    setAutoCompleteLoading(true);
                    const data = await fetchAutoCompleteSheetData('',sheetFilter,searchValue);
                    if(active){
                        setSheetMappingData(data);
                        setAutoCompleteLoading(false);
                    }
                }
            )();
        }
        return () => {
            active = false;
        }
    },[sheetFilter,searchValue])

    const handleChangeAutoComplete = (value) => {
        const address = value?.Address ? value?.Address : '';
        setSignalAddress(address);
    }

    const handleModalSubmit = () => {
        setOpen(false);
        setSearchValue('');
        setSheetFilter('');
        setFields((prevUpdate) => ({...prevUpdate, "SigAddr": signalAddress }));
    } 

    const handleClearAddress = () => {
        setFields((prevUpdate) => ({...prevUpdate, "SigAddr": '' }));
    }


    return (
        <>
            <Breadcrumb title={location.state?.rowId !== '' &&  location.state?.rowId !== undefined ? 'Edit' : 'Add New' }>
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                    Dashboard
                </Typography>
                <Typography component={Link} to={location.pathname.includes('mapping') ? '/mapping/can/transmit-messages' : '/can/transmit-messages'} variant="subtitle2" color="primary" className="link-breadcrumb">
                ECUTransmitMessages
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                {location.state?.rowId !== '' &&  location.state?.rowId !== undefined ? 'Edit' : 'New' }
                </Typography>
            </Breadcrumb>
            <Box component="section">
                <Grid className="contentBox">

                    <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                        <Grid item>
                            <Button
                                component={Link} 
                                to={location.pathname.includes('mapping') ? '/mapping/can/transmit-messages' : '/can/transmit-messages'}
                                variant="contained"
                                size="small"
                                color="primary"
                                sx={{mr:3}}
                            >Back 
                            </Button>
                        </Grid>
                    </Grid>
                    
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormControl
                                margin="dense"
                                fullWidth
                            >
                                <InputLabel id="demo-simple-select-standard-label">ECMID</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    sx={{
                                        "&:focus": {
                                            backgroundColor: "#ffffff"
                                        }
                                    }}
                                    label="ECMID"
                                    value={fields.ECMID}
                                    onChange={changeHandler}
                                    name="ECMID"
                                    error={fields.ECMID === ""}
                                >
                                    <MenuItem value="">Select ECMID</MenuItem>
                                    {ECMID?.map((opt) => (
                                        <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText sx={{color:"#d32f2f"}} >{fields.ECMID === "" ? "Required Field!" : false}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="PGN"
                                label="PGN"
                                name="PGN"
                                value={fields.PGN}
                                onChange={changeHandler}
                                error={fields.PGN === ""}
                                helperText={fields.PGN === "" ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="StartByte"
                                label="StartByte"
                                name="StartByte"
                                value={fields.StartByte}
                                onChange={changeHandlerInt}
                                error={fields.StartByte === ""}
                                helperText={fields.StartByte === "" ? "Required Field!" : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="StartBit"
                                label="StartBit"
                                name="StartBit"
                                value={fields.StartBit}
                                onChange={changeHandlerInt}
                                error={fields.StartBit === ""}
                                helperText={fields.StartBit === "" ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Len"
                                label="Len"
                                name="Len"
                                value={fields.Len}
                                onChange={changeHandlerInt}
                                error={fields.Len === ""}
                                helperText={fields.Len === "" ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="Scaling"
                                label="Scaling"
                                name="Scaling"
                                value={fields.Scaling}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="Offset"
                                label="Offset"
                                name="Offset"
                                value={fields.Offset}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="NANVal"
                                label="NANVal"
                                name="NANVal"
                                value={fields.NANVal}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                            />        
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="DType"
                                label="DType"
                                name="DType"
                                value={fields.DType}
                                onChange={changeHandler} 
                                error={fields.DType === ""}
                                helperText={fields.DType === "" ? "Required Field!" : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="SPN"
                                label="SPN"
                                name="SPN"
                                value={fields.SPN}
                                onChange={changeHandlerInt}
                                error={fields.SPN === ""}
                                helperText={fields.SPN === "" ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={9} sm={2.6} md={3}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="SigAddr"
                                label="SigAddr"
                                name="SigAddr"
                                value={fields.SigAddr}
                                error={fields.SigAddr === ""}
                                helperText={fields.SigAddr === "" ? "Required Field!" : false}
                                disabled={true}
                             />
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={handleClickOpen}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1.5} sm={0.7} md={0.5}>
                            <IconButton 
                                size='large'
                                color='inherit'
                                sx={{mt:1.5}}
                                onClick={handleClearAddress}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Addr"
                                label="Addr"
                                name="Addr"
                                value={fields.Addr}
                                error={fields.Addr === ""}
                                onChange={changeHandler}
                                helperText={fields.Addr === "" ? "Required Field!" : false}
                             />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                //sx={{mt: { xs:'24px',sm:'8px',md:'8px'}}}
                                fullWidth
                                margin="dense"
                                id="comments"
                                label="Comments"
                                name="comments"
                                value={fields.comments}
                                multiline
                                rows={4}
                                onChange={changeHandler}
                                error={fields.comments === ""}
                                helperText={fields.comments === "" ? "Required Field!" : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <Grid container direction="row" spacing={1} display={'flex'} justifyContent={'flex-start'}>
                            <Grid item>
                                <Button
                                    onClick={handleSubmit}
                                    variant="contained"
                                    size="medium"
                                    color="primary"
                                    sx={{mt:2}}
                                >Submit
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    component={Link} 
                                    to={location.pathname.includes('mapping') ? '/mapping/can/transmit-messages' : '/can/transmit-messages'}
                                    variant="contained"
                                    size="medium"
                                    color="error"
                                    sx={{mt:2}}
                                >Cancel
                                </Button>
                            </Grid>
                        </Grid> 
                    </Grid> 
                    <AddressModal 
                        open={open}
                        options={options}
                        autoCompleteName={"SigAddr"}
                        onClose={handleClose}
                        sheetFilter={sheetFilter}
                        handleSheetFilter={handleSheetFilter} 
                        handleModalSubmit={handleModalSubmit}
                        autoCompleteOptions={sheetMappingData}
                        autoCompleteLoading={autoCompleteLoading}
                        handleChangeAutoComplete={handleChangeAutoComplete}
                        handleSearchValueAutoComplete={handleSearchValueAutoComplete}
                    />
                </Grid>
            </Box>
        </>
    );
};

export default AddNewTransmitMessages;
